import { API_URL } from './Api';

export const API_URN = '/v1/public/cadastro';

export function CADASTRAR_MEUCORREIOS_PF(body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/pf`,
    options: {
      method: 'POST',
      headers: {
        'X-Forwarded-For': ipAddress,
        'Content-Type': 'application/json',
        //        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function CADASTRAR_MEUCORREIOS_PJ(body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/pj`,
    options: {
      method: 'POST',
      headers: {
        'X-Forwarded-For': ipAddress,
        'Content-Type': 'application/json',
        //        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
/*export function RECADASTRAMENTO_PF(idCorreios, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/recadastramento`,
    options: {
      method: 'PATCH',
      headers: {
        'X-Forwarded-For': ipAddress,
        'Content-Type': 'application/json',
        //        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
*/
export function IDCORREIOS_PESQUISA(id) {
  return {
    url: `${API_URL}${API_URN}/pf/${id}`,
    options: {
      method: 'GET',
      //      headers: {
      //        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      //      },
    },
  };
}
export function IDCORREIOS_PESQUISA_PJ(id) {
  return {
    url: `${API_URL}${API_URN}/pj/${id}`,
    options: {
      method: 'GET',
      //      headers: {
      //        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      //      },
    },
  };
}
export function ATIVAR_IDCORREIOS(body) {
  return {
    url: `${API_URL}${API_URN}/ativacao`,
    options: {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        //        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function ENVIAR_TOKEN(id, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/token/${id}`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        //      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}

export function ENVIAR_TOKEN_PF(id, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/token/pf/${id}`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        //      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function ENVIAR_TOKEN_PJ(id, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/token/pj/${id}`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        //      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}

export function CONSULTAR_TOKEN(id) {
  return {
    url: `${API_URL}${API_URN}/${id}/token`,
    options: {
      method: 'GET',
      //      headers: {
      //        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      //      },
    },
  };
}
export function MEUCORREIOS_PESQUISA(id) {
  return {
    url: `${API_URL}${API_URN}/meucorreios/${id}`,
    options: {
      method: 'GET',
      //      headers: {
      //        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      //      },
    },
  };
}
export function IDCORREIOS_PESQUISA_PJ_AN8(id) {
  return {
    url: `${API_URL}${API_URN}/pj/an8/${id}`,
    options: {
      method: 'GET',
      //      headers: {
      //        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      //      },
    },
  };
}
/*
export function LISTAR_NECESSIDADES_ESPECIAIS() {
  return {
    url: `${API_URL}${API_URN}/pf/necessidadesespeciais`,
    options: {
      method: 'GET',
      //      headers: {
      //        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      //      },
    },
  };
}
  */
export function ALTERAR_SENHA(body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/senha-redefinicao`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
      },
      body: JSON.stringify(body),
    },
  };
}
export function ALTERAR_SENHA_RESET(body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/reset-senha-redefinicao`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
      },
      body: JSON.stringify(body),
    },
  };
}

export function ESQUECI_SENHA_PJ(body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/esqueci-senha-pj`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
      },
      body: JSON.stringify(body),
    },
  };
}

export function GET_TELEFONE_INTERNACIONAL(idCorreios) {
  return {
    url: `${API_URL}${API_URN}/pj/${idCorreios}/telefone-internacional`,
    options: {
      method: 'GET',
    },
  };
}
/*
export function GET_TELEFONE_INTERNACIONAL(idCorreios) {
  return {
    url: 'data:application/json,{"valor":"S"}',
    options: {
      method: 'GET',
    },
  };
}*/

export function ESQUECI_SENHA_PF(body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/esqueci-senha-pf`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
      },
      body: JSON.stringify(body),
    },
  };
}
